import { useSearchParams } from "react-router-dom"

export type SpecialOfferType = "secondTrial" | "expiring"

function parseSpecialOffer(params: URLSearchParams) {
  const specialOffer = params.get("offer")

  if (specialOffer == null) {
    return undefined
  }

  return specialOffer as SpecialOfferType
}

export type DebugActiveSubscriptionType = "premium" | "ultimate"

function parseDebugActiveSubscription(params: URLSearchParams) {
  const activeSubscription = params.get("activeSub")

  if (activeSubscription == null) {
    return undefined
  }

  return activeSubscription as DebugActiveSubscriptionType
}

function useQueryParams() {
  const params = useSearchParams()[0]

  const debug = params.get("debug") === "true"
  let hasDiscount = params.get("discount") == "true"
  const specialOffer = parseSpecialOffer(params)

  if (debug && specialOffer) {
    hasDiscount = true
  }

  return {
    debug,
    searchParams: params,
    darkMode:
      params.get("darkMode") === "true" || params.get("darkmode") === "true",
    language: params.get("language") ?? "en",
    hasTrial: !(params.get("hasTrial") == "false"),
    hasDiscount,
    isUltimate: params.get("plan") == "ultimate",
    isPremiumUser: params.get("premiumUser") === "true",
    isLapsed: params.get("lapsed") == "true",
    isUltimateLaunch: params.get("ultimateLaunch") == "true",
    useYearlyForDiscount: params.get("yearlyDiscount") == "true",
    ultimateOnly: params.get("ultimateOnly") == "true",
    toggleFreeTrial: params.get("toggleFreeTrial") === "true",
    beforeYouGo: params.get("beforeYouGo") === "true",
    postPurchaseFlow: params.get("postPurchaseFlow") === "true",
    specialOffer,
    debugSubscription: parseDebugActiveSubscription(params),
    useYearlyForPromoTrial: params.get("yearlyPromoTrial") === "true",
    showUltimateInExpiration: params.get("showUltimateInExpiration") === "true",
    alternateImageSet: params.get("alternateImageSet") === "true",
    alternateClose: params.get("alternateClose") === "true",
    alternateTAPromo: params.get("alternateTAPromo") === "true",
    ignoreInset: params.get("ignoreInset") === "true",
    show3month: params.get("show3month") === "true",
    expandPaymentPadding: params.get("expandPaymentPadding") === "true",
    debugLongestSubscription: params.get("debugLongestSubscription") === "true",
    showLifetimeSecondStep: params.get("showLifetimeSecondStep") === "true",
    showBubbleFeatures: params.get("showBubbleFeatures") === "true",
    hasPro: params.get("hasPro") === "true",
    defaultToUltimate: params.get("defaultToUltimate") === "true",
    showChoosePlanTitle: params.get("showChoosePlanTitle") === "true",
  }
}

export type QueryParams = ReturnType<typeof useQueryParams>

export default useQueryParams
